The label text for the verification button.
